import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {ChangePasswordComponent} from "./change-password.component";

const routes: Routes = [
  {
    path: 'change-password',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: ChangePasswordComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChangePasswordRoutingModule { }
